import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconPpt48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="ppt">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 23C1 21.3431 2.34315 20 4 20H35C36.6569 20 38 21.3431 38 23V33C38 34.6569 36.6569 36 35 36H4C2.34315 36 1 34.6569 1 33V23ZM4 22C3.44772 22 3 22.4477 3 23V33C3 33.5523 3.44772 34 4 34H35C35.5523 34 36 33.5523 36 33V23C36 22.4477 35.5523 22 35 22H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9 5C9 2.23858 11.2386 0 14 0H32C32.2589 0 32.5078 0.100428 32.6941 0.280156L46.6941 13.7802C46.8896 13.9686 47 14.2285 47 14.5V43C47 45.7614 44.7614 48 42 48H14C11.2386 48 9 45.7614 9 43V35H11V43C11 44.6569 12.3431 46 14 46H42C43.6569 46 45 44.6569 45 43V15.5H34C32.3431 15.5 31 14.1569 31 12.5V2H14C12.3431 2 11 3.34315 11 5V21H9V5ZM33 3.35347L43.5223 13.5H34C33.4477 13.5 33 13.0523 33 12.5V3.35347Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                d="M11.8683 23.6C12.6123 23.6 13.2563 23.724 13.8003 23.972C14.3523 24.22 14.7763 24.572 15.0723 25.028C15.3683 25.484 15.5163 26.024 15.5163 26.648C15.5163 27.264 15.3683 27.804 15.0723 28.268C14.7763 28.724 14.3523 29.076 13.8003 29.324C13.2563 29.564 12.6123 29.684 11.8683 29.684H10.1763V32H8.23233V23.6H11.8683ZM11.7603 28.1C12.3443 28.1 12.7883 27.976 13.0923 27.728C13.3963 27.472 13.5483 27.112 13.5483 26.648C13.5483 26.176 13.3963 25.816 13.0923 25.568C12.7883 25.312 12.3443 25.184 11.7603 25.184H10.1763V28.1H11.7603ZM20.5402 23.6C21.2842 23.6 21.9282 23.724 22.4722 23.972C23.0242 24.22 23.4482 24.572 23.7442 25.028C24.0402 25.484 24.1882 26.024 24.1882 26.648C24.1882 27.264 24.0402 27.804 23.7442 28.268C23.4482 28.724 23.0242 29.076 22.4722 29.324C21.9282 29.564 21.2842 29.684 20.5402 29.684H18.8482V32H16.9042V23.6H20.5402ZM20.4322 28.1C21.0162 28.1 21.4602 27.976 21.7642 27.728C22.0682 27.472 22.2202 27.112 22.2202 26.648C22.2202 26.176 22.0682 25.816 21.7642 25.568C21.4602 25.312 21.0162 25.184 20.4322 25.184H18.8482V28.1H20.4322ZM27.0817 25.184H24.3937V23.6H31.7137V25.184H29.0257V32H27.0817V25.184Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
